import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import AdminCable from '../components/helpers/AdminCable';

import map from 'lodash/map';

import '../styles/css/admin.css';


const mapStateToProps = state => ({ currentUser: state.loaders.currentProject, links: (state.admin || {links: []}).links });

const matchDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch);
};



class AdminLinks extends Component {
  
  render() {
    const {links} = this.props
    return <div className="admin-links">
      {map(links, (link) =>(
        <div className="admin-link-item" key={link.id}>
          <img alt="" src={`https://image.thum.io/get/auth/2657-shorbymoneyrocketgogogo/noanimate/width/700/${link.short_url + '?notrack=true&'+ Math.ceil(new Date(link.updated_at).getTime() / 1000)}`} />
        </div>
      ))}
    </div>
  }
}


class AdminPage extends Component {
  
  render() {
    const {links} = this.props
    return (<React.Fragment>
      <AdminCable />
      
      <AdminLinks links={links} />
      
    </React.Fragment>)
  }
}


export default connect(mapStateToProps, matchDispatchToProps)(AdminPage);


// WEBPACK FOOTER //
// ./src/containers/AdminPage.js